import AppPromotionBannerStorage from './AppPromotionBannerStorage';

export default class AppPromotionBanner {
    static #instance: AppPromotionBanner | null = null;

    readonly #storage: AppPromotionBannerStorage = new AppPromotionBannerStorage();

    readonly #banner: HTMLElement | null = document.querySelector(
        '[data-role="app-promotion-banner"]'
    );

    readonly #dismiss = (): void => {
        if (this.#banner === null) {
            return;
        }

        this.#banner.hidden = true;

        this.#storage.markAsDismissed().catch((): void => undefined);
    };

    private constructor() {
        if (this.#banner === null) {
            return;
        }

        this.#banner
            .querySelector('[data-role="app-promotion-banner-close"]')
            ?.addEventListener('click', this.#dismiss);

        this.#showWhenNotDismissed().catch((): void => undefined);
    }

    public static getInstance(): AppPromotionBanner {
        if (AppPromotionBanner.#instance === null) {
            AppPromotionBanner.#instance = new AppPromotionBanner();
        }

        return AppPromotionBanner.#instance;
    }

    public static destroyInstance(): void {
        AppPromotionBanner.#instance = null;
    }

    async #showWhenNotDismissed(): Promise<void> {
        if (this.#banner === null || (await this.#storage.isDismissed())) {
            return;
        }

        this.#banner.hidden = false;
    }
}
